import apiClient from '@/shared/services/apiClient';

const API_VERSION = 2;
const RESOURCE_URL = '/api/itineraries';
const SUPPLIER_SEARCH_URL = '/api/pessoa/jsonlist/fornecedor';

export default {
  fetchAll(params = {}) {
    return apiClient.get(RESOURCE_URL, { params, apiVersion: API_VERSION });
  },

  searchSuppliers(search) {
    return apiClient.post(SUPPLIER_SEARCH_URL, { search }, { apiVersion: API_VERSION });
  },

  createDraft() {
    return apiClient.post(RESOURCE_URL + '/draft', null, { apiVersion: API_VERSION });
  },

  updateDetails(itineraryId, details) {
    return apiClient.patch(RESOURCE_URL + '/' + itineraryId + '/details', details, {
      apiVersion: API_VERSION,
    });
  },

  fetchHistory(itineraryId, params = {}) {
    return apiClient.get(RESOURCE_URL + '/' + itineraryId + '/historico', {
      params,
      apiVersion: API_VERSION,
    });
  },

  searchPessoas(itineraryId, search) {
    return apiClient.post(
      RESOURCE_URL + '/' + itineraryId + '/pessoas-juridicas/lookup',
      { search: search },
      { apiVersion: API_VERSION }
    );
  },

  syncPessoas(itineraryId, personIds) {
    return apiClient.put(
      RESOURCE_URL + '/' + itineraryId + '/pessoas-juridicas',
      { person_ids: personIds },
      { apiVersion: API_VERSION }
    );
  },

  submit(itineraryId) {
    return apiClient.post(RESOURCE_URL + '/' + itineraryId + '/submit', null, {
      apiVersion: API_VERSION,
    });
  },

  remove(itineraryId) {
    return apiClient.delete(RESOURCE_URL + '/' + itineraryId, {
      apiVersion: API_VERSION,
    });
  },

  updateStatus(itineraryIds, status) {
    return apiClient.patch(RESOURCE_URL + '/status', {
      statusRecord: itineraryIds,
      status: status,
    }, { apiVersion: API_VERSION });
  },

  exportSpreadsheet(itineraryIds) {
    return apiClient.post(
      RESOURCE_URL + '/export',
      { itinerary_ids: itineraryIds },
      { apiVersion: API_VERSION, responseType: 'blob' }
    );
  },

  importSpreadsheet(file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post(RESOURCE_URL + '/import', formData, {
      apiVersion: API_VERSION,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
